var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Box } from '@lucidlink/uicore';
import { useGetGuestLink } from '../../../../query-hooks/queries/useGetGuestLink';
import { LinkExpiration } from './LinkExpiration';
import { LinkExpirationEdit } from './LinkExpirationEdit';
import { LinkExpirationView } from './LinkExpirationView';
export const LinkSettingsTab = ({ filespaceId, guestLinkId, workspaceId, }) => {
    _react_refresh_temp_2();
    const [isEditing, setIsEditing] = useState(false);
    const { data } = useGetGuestLink({ filespaceId, workspaceId }, guestLinkId);
    if (!data) {
        return null;
    }
    const { expiresAt, status } = data;
    const isExpired = expiresAt !== null &&
        (status === 'expired' || expiresAt.getTime() < Date.now());
    const mode = getExpirationMode(isEditing, expiresAt);
    const renderExpirationSection = () => {
        switch (mode) {
            case 'empty':
                return null;
            case 'view':
                return (expiresAt && (_jsx(LinkExpirationView, { expiresAt: expiresAt, filespaceId: filespaceId, guestLinkId: guestLinkId, onEdit: () => setIsEditing(true), workspaceId: workspaceId })));
            case 'edit':
                return (_jsx(LinkExpirationEdit, { expiresAt: expiresAt, filespaceId: filespaceId, guestLinkId: guestLinkId, onExit: () => setIsEditing(false), workspaceId: workspaceId }));
        }
    };
    return (_jsx(Box, { "data-testid": "guest-link-link-settings-tab", gap: "m", orientation: "vertical", children: _jsx(LinkExpiration, { isExpired: isExpired, mode: mode, onSetExpiration: () => setIsEditing(true), renderExpirationSection: renderExpirationSection, workspaceId: workspaceId }) }));
};
_react_refresh_temp_1 = LinkSettingsTab;
$RefreshReg$(_react_refresh_temp_1, "LinkSettingsTab");
_react_refresh_temp_2(LinkSettingsTab, "BuAJ39UDQ9amIEtAlp5xUYDKhIE=", false, () => [useGetGuestLink]);
const getExpirationMode = (isEditing, expiresAt) => {
    if (isEditing) {
        return 'edit';
    }
    return expiresAt ? 'view' : 'empty';
};
